module.exports = __webpack_public_path__ + "static/img/mz.535d1f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/mz.png
// module id = 499
// module chunks = 1